export default __webpack_public_path__ + "static/media/stub-avatar.c9ffdfe3.webp";